export default __webpack_public_path__ + "static/media/vip-icon-home-mobile.2264f473.webp";